import { Button, withStyles } from '@material-ui/core';

/**
 * A left-aligned option button used inside attachment / action popovers.
 * Shared so multiple screens render the same option-row look.
 */
const ButtonOption = withStyles({
    root: {
        '&:hover': {
            backgroundColor: '#ecf2fb'
        },
        padding: '10px 20px 10px 20px',
        justifyContent: 'flex-start'
    }
})(Button);

export default ButtonOption;
